(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var slider = document.querySelector('.custom-slider');
  if (!slider) return;

  var slidesWrapper = slider.querySelector('.slides');
  var slides = slider.querySelectorAll('.slide');
  var prevBtn = slider.querySelector('.prev');
  var nextBtn = slider.querySelector('.next');
  var thumbs = slider.querySelectorAll('.slider-nav img');
  var dots = slider.querySelectorAll('.dots span');
  var currentIndex = 0;
  var slideCount = slides.length;
  var autoSlideInterval = 5000;

  // Drag/swipe variables
  var startX = 0;
  var currentX = 0;
  var isDragging = false;

  function updateSlider(index) {
    if (index < 0) index = slideCount - 1;
    if (index >= slideCount) index = 0;
    currentIndex = index;

    slidesWrapper.style.transition = 'transform 0.4s ease';
    slidesWrapper.style.transform = 'translateX(' + (-index * 100) + '%)';

    thumbs.forEach(t => t.classList.remove('active'));
    if (thumbs[index]) thumbs[index].classList.add('active');

    dots.forEach(d => d.classList.remove('active'));
    if (dots[index]) dots[index].classList.add('active');
  }

  prevBtn.addEventListener('click', function() { updateSlider(currentIndex - 1); resetAutoSlide(); });
  nextBtn.addEventListener('click', function() { updateSlider(currentIndex + 1); resetAutoSlide(); });

  thumbs.forEach(function(thumb, i) {
    thumb.addEventListener('click', function() { updateSlider(i); resetAutoSlide(); });
  });

  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { updateSlider(i); resetAutoSlide(); });
  });

  var autoSlide = setInterval(function() { updateSlider(currentIndex + 1); }, autoSlideInterval);

  function resetAutoSlide() {
    clearInterval(autoSlide);
    autoSlide = setInterval(function() { updateSlider(currentIndex + 1); }, autoSlideInterval);
  }

  // ----- DRAG & SWIPE HANDLING -----
  function dragStart(e) {
    isDragging = true;
    startX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    currentX = startX;
    slidesWrapper.style.transition = 'none';
  }

  function dragMove(e) {
    if (!isDragging) return;
    currentX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    var diff = currentX - startX;
    slidesWrapper.style.transform = 'translateX(' + ((-currentIndex * 100) + (diff / slider.offsetWidth) * 100) + '%)';
  }

  function dragEnd() {
    if (!isDragging) return;
    isDragging = false;
    var diff = currentX - startX;

    if (Math.abs(diff) > slider.offsetWidth * 0.2) {
      if (diff > 0) {
        updateSlider(currentIndex - 1);
      } else {
        updateSlider(currentIndex + 1);
      }
    } else {
      updateSlider(currentIndex); // snap back
    }
    resetAutoSlide();
  }

  // Desktop drag events
  slidesWrapper.addEventListener('mousedown', dragStart);
  slidesWrapper.addEventListener('mousemove', dragMove);
  slidesWrapper.addEventListener('mouseup', dragEnd);
  slidesWrapper.addEventListener('mouseleave', dragEnd);

  // Mobile swipe events
  slidesWrapper.addEventListener('touchstart', dragStart, { passive: true });
  slidesWrapper.addEventListener('touchmove', dragMove, { passive: true });
  slidesWrapper.addEventListener('touchend', dragEnd);

  updateSlider(0);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mix_and_match"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var scroller = document.getElementById('mm-scroll-{{ section.id }}');
  var track    = document.getElementById('mm-track-{{ section.id }}');
  if (!scroller || !track) return;

  var GAP = 12; // keep in sync with --mm-gap

  function layout() {
    var isMobile = window.innerWidth <= 767;

    // Reset any previous inline sizing when not mobile
    if (!isMobile) {
      scroller.style.removeProperty('--mm-cardW');
      scroller.style.scrollPaddingLeft = '';
      scroller.style.scrollPaddingRight = '';
      track.style.paddingRight = '';
      // ensure we aren't offset on desktop/tablet
      scroller.scrollLeft = 0;
      return;
    }

    // Compute card width so 3 cards (0.5 + 1 + 1 + 0.5) fill viewport width
    var W = scroller.clientWidth;
    // There are two gaps between the three visible cards
    var cardW = Math.max(120, Math.round((W - 2 * GAP) / 3));

    // Apply card width via CSS var
    scroller.style.setProperty('--mm-cardW', cardW + 'px');

    // Set scroll padding so snapping lands at ".5 1 1 .5"
    scroller.style.scrollPaddingLeft  = (cardW / 2) + 'px';
    scroller.style.scrollPaddingRight = (cardW / 2) + 'px';

    // Add right padding so the last item can half-peek
    track.style.paddingRight = (cardW / 2) + 'px';

    // Initialize position to show ".5 1 1 .5"
    // (offset by half a card so first is half on the left)
    scroller.scrollLeft = cardW / 2;
  }

  // Handle very small counts gracefully
  function adjustForFewCards() {
    var cards = track.querySelectorAll('.mm-card');
    var count = cards.length;
    if (count <= 1) {
      // no need for scroll; let it be full width
      scroller.style.setProperty('--mm-cardW', scroller.clientWidth + 'px');
      track.style.paddingRight = '0px';
      scroller.scrollLeft = 0;
    } else if (count === 2 && window.innerWidth <= 767) {
      // Show two cards full with .5/.5 peeks using same math:
      var W = scroller.clientWidth;
      // For two cards visible, we want pattern: .5 1 1 .5 still => 3 card widths
      // use same 1/3 width; layout() already handles it
    }
  }

  layout();
  adjustForFewCards();

  // Recalculate on resize/orientation changes
  var resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      layout();
      adjustForFewCards();
    }, 100);
  });

  // If section becomes visible via theme editor toggles, re-layout
  document.addEventListener('shopify:section:load', layout);
  document.addEventListener('shopify:section:select', layout);
});

  } catch(e) { console.error(e); }
})();
})();
